import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Banner } from '@citrus/banner';


class FlashMessage extends Component {

  render() {
    // If no message has been provided then don't show the banner
    if (!this.props.message || !this.props.message.text)
      return null;
/*
    // if mobile or public, don't add the goofy padding
    let citrusHeaders = window.document.getElementsByClassName("c-header");
    let isMobileView = (citrusHeaders.length === 0 || window.location.search.indexOf("mobile=true") > -1);

    // Determine which css class to use
    const messageTypeCss = classnames('banner-message fadeout', {
      'success': this.props.message.type === 'success',
      'error': this.props.message.type === 'error',
      'information': this.props.message.type === 'information'
    },
      { 'flash-message-notification-banner': this.props.reduceTopPadding === false && !isMobileView }
    );
*/
    // A message was provided. Show the flash message
    let title = this.props.message.title;
    let text = this.props.message.text;
    return (
      <Banner
        id="flash-message-banner"
        onDismiss={() => this.dismissMessage()}
        type={this.props.message.type}
        visible={true}>
          <p><span>{title}</span>{text}</p>
      </Banner>
    );
  }


  dismissMessage() {
    this.props.dismissMessage();
  }

  dismissErrorMessage() {
    if (this.props.message.type === 'error') {
      this.props.dismissMessage();
    }
  }
}

FlashMessage.propTypes = {
  dismissMessage: PropTypes.func,
  message: PropTypes.object,  
  reduceTopPadding: PropTypes.bool
};

FlashMessage.defaultProps = {
  reduceTopPadding: false
};

export default FlashMessage;

